import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APPLICATION_ROLES } from "services/endPoints";
import { privateRequest } from "services/privateRequest";

const initialState = {
  loading: false, //Button Loader
  topBarDropDownData: {
    open: false,
    data: null,
  },
  openCreateIssue: { open: false, type: "", relatedWorkItem: null },
  sidebarOpen: true,
  openDeleteStage: false,
  projectMoreIconDropDown: {
    open: false,
    data: null,
  },
  applicationRoleList: [],
  applicationRoleTotalCount: 0,
  applicationRoleLoading: false,
};

export const getApplicationRoleList = createAsyncThunk(
  "global/getApplicationRoleList",
  async ({ pageNo = 1, pageSize = 25, search = "" } = {}) => {
    const res = await privateRequest.get(APPLICATION_ROLES, {
      params: { pageNo, pageSize, search },
    });
    return {
      data: res?.data?.data?.data || [],
      count: res?.data?.data?.count || {},
    };
  }
);

const globalSlice = createSlice({
  name: "global",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getApplicationRoleList.pending, (state) => {
        state.applicationRoleLoading = true;
      })
      .addCase(getApplicationRoleList.fulfilled, (state, action) => {
        state.applicationRoleList = action.payload.data;
        state.applicationRoleTotalCount = action.payload.count?.total ?? 0;
        state.applicationRoleLoading = false;
      })
      .addCase(getApplicationRoleList.rejected, (state) => {
        state.applicationRoleLoading = false;
      });
  },
  reducers: {
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTopBarDropDownData: (state, action) => {
      state.topBarDropDownData = action.payload;
    },
    setProjectMoreIconDropDown: (state, action) => {
      state.projectMoreIconDropDown = action.payload;
    },
    setOpenCreateIssue: (state, action) => {
      state.openCreateIssue = action.payload;
    },
    setOpenDeleteStage: (state, action) => {
      state.openDeleteStage = action.payload;
    },
  },
});

export default globalSlice.reducer;
export const {
  setSidebarOpen,
  setSupportSidebarOpen,
  setLoading,
  setTopBarDropDownData,
  setOpenCreateIssue,
  setOpenDeleteStage,
  setProjectMoreIconDropDown,
} = globalSlice.actions;
